var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"download-nav"},[_c('div',{staticClass:"close",on:{"click":_vm.close}}),_c('div',{staticClass:"ico"}),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',{staticClass:"bt",on:{"click":_vm.download}},[_vm._v(" 打开APP ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }